import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Project page components
import FormField from "components/Form/FormField";

import { useEffect, useState } from "react";
import { RequestService } from "services/RequestService";
import { Autocomplete } from "@mui/material";
function AddForm({ formData }) {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const { budget, actualExpenditure, budgetStatus } = formField;
  const [budgetstate, setBudgetstate] = useState([]);
  const {
    budget: budgetV,
    actualExpenditure: actualExpenditureV,
    budgetStatus: budgetStatusV,
  } = values;
  const getAllBudgets = async () => {
    let options = [];
    await RequestService.get("/Project/ProjectBudgetList").then((response) => {
      if (response.status === 200 && response.data.data !== null) {
        let js = response.data.data;
        Object.entries(js).forEach(([key, value]) => {
          options.push({
            value: value,
            label: key,
          });
        });
      }
    });
    setBudgetstate(options);
  };
  useEffect(() => {
    getAllBudgets();
  }, []);
  const isOptionEqualToValue = (option, value) => option.id === value.id;

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">المعلومات الرئيسية للمشروع</MDTypography>
      </MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              type={budget.type}
              label={budget.label}
              name={budget.name}
              value={budgetV}
              placeholder={budget.placeholder}
              error={errors.budget && touched.budget}
              success={budgetV.length > 0 && !errors.budget}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormField
              type={actualExpenditure.type}
              label={actualExpenditure.label}
              name={actualExpenditure.name}
              value={actualExpenditureV}
              placeholder={actualExpenditure.placeholder}
              error={errors.actualExpenditure && touched.actualExpenditure}
              success={actualExpenditureV.length > 0 && !errors.actualExpenditure}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Autocomplete
              value={budgetstate.find(option => option.value === values.budgetStatus) || null}
              variant="outlined"
              options={budgetstate}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              renderInput={(params) => (
                <FormField
                  {...params}
                  variant="outlined"
                  label={budgetStatus.label}
                  name={budgetStatus.name}
                  placeholder={budgetStatus.placeholder}
                />
              )}
              onChange={(e, v) => {
                setFieldValue("budgetStatus", v ? v.value : null);
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

AddForm.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default AddForm;
